import './Modal.css';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import IconButton from "@material-ui/core/IconButton";
import React from "react";

const Modal = ({ handleClose, show, children }) => {
    const showHideClassName = show ? "modal display-block" : "modal display-none";

    return (
        <div className={showHideClassName} onClick={() => handleClose()}>
            <section className="modal-main" onClick={
                e => e.stopPropagation()
            }>
                {children}
            </section>

            <IconButton style={{ color: "#ffffff" }} aria-label="call" onClick={() => handleClose()}>
                <HighlightOffIcon/>
            </IconButton>
        </div>
    );
};

export default Modal